import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addInterpreter } from 'slices/interpreterSlice';
import { interpreterSelector } from 'slices/interpreterSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/interpreterSlice';
import toast from 'react-hot-toast';
import { updateInterpreter } from 'slices/interpreterSlice';
import { fetchInterpreters } from 'slices/interpreterSlice';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { stateSelector } from 'slices/stateSlice';
import { citySelector } from 'slices/citySlice';
import { languageSelector } from 'slices/languageSlice';
import { Select } from 'components/common/Select';
import { fetchLanguages } from 'slices/languageSlice';
import { fetchZones } from 'slices/zoneSlice';
import { fetchCitys } from 'slices/citySlice';
import { fetchStates } from 'slices/stateSlice';
import CustomMultiSelect from 'components/common/CustomMultiSelect';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import PhoneInput from 'components/common/PhoneInput';
import { Switch } from '@mui/material';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { ProfilePicture } from 'components/common/ProfilePicture';
import { cdn } from 'constants/common';
import { UploadButton } from '@bytescale/upload-widget-react';
import InterpreterRate from 'components/type/InterpreterRate';

const apiService = new Api();

const EMPLOYMENT_TYPE_OPTIONS = [
  { value: 'permanent', label: 'Permanent' },
  { value: 'freelancer', label: 'Freelancer' },
];

const AddInterpreterForm = ({ item, handleClose, callback, show, statusPerm }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm();
  // Freelancers are not tied to a school zone, so the Zone field is hidden for them
  const employmentType = watch('employment_type');
  const { error, loader } = useSelector(interpreterSelector);
  const [status, setStatus] = useState(1)
  const { state: states } = useSelector(stateSelector);
  const [allStates, setAllStates] = useState([]);
  const [filterStates, setfilterStates] = useState({
    label: "",
    value: ""
  })
      const [filterZone, setFilterZone] = useState({
      label: "",
      value: ""
    })
  const fileInputRef = React.useRef(null);
  const [localImage, setLocalImage] = React.useState('')
  const resetFileInput = () => {
    setLocalImage("")
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };


  const clearAll = () => {
    resetFileInput()
    setValue("first_name", '');
    setValue("last_name", '');
    setValue("email");
    setValue('password', '');
    setValue('password_confirmation', '');
    setValue("phone", '');
    setValue('address', '')
    setValue("zip_code", "");
    setValue("city_id", "")
    setValue("state_id", [])
    setValue("language_ids", []);
    setValue("employment_type", "permanent");
    setValue("zone_id", "");
    setFilterZone(null);
    setStatus(1)

    clearErrors("city_id");
    clearErrors("state_id");
    clearErrors("language_ids");
    clearErrors("employment_type");
    clearErrors("zone_id");
    dispatch(setError({}))
    setLanguageState([])
  }

  useEffect(() => {
    setValue("image", item?.user?.image || '')
    setValue('first_name', item?.first_name || '');
    setValue('last_name', item?.last_name || '');
    setValue('email', item?.user?.email || '')
    setValue('phone', item?.phone || '');
    setValue('address', item?.address || '')
    setValue('zip_code', item?.zip_code || '');
    setValue('state_id', item?.state_id || '');
    setValue('city_id', item?.city_id || '');
    setValue("language_ids", item?.languages?.map(language => language.language_id) || [])
    setValue('employment_type', item?.employment_type || 'permanent');
    setStatus((typeof (item?.status) == "number") ? item?.status : 1)
    return () => clearAll()

  }, [item]);

  // Drop any previously picked zone when switching to freelancer — react-hook-form
  // keeps values of unmounted Controllers, so it would otherwise still be submitted.
  useEffect(() => {
    if (employmentType === 'freelancer') {
      setValue('zone_id', '');
      setFilterZone(null);
      clearErrors('zone_id');
    }
  }, [employmentType]);


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchInterpreters())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    data = {
      ...data,
      status,
    };
    // Send an empty zone for freelancers — Laravel converts "" to NULL,
    // whereas an undefined value would be appended as the string "undefined".
    if (data.employment_type === 'freelancer') {
      data.zone_id = '';
    }
    const formData = new FormData();
    for (let key in data) {
      if (key === "image") {
        formData.append("image", data[key])
      } else if (key === "language_ids" && Array.isArray(data[key])) {
        data[key].forEach(id => {
          formData.append("language_ids[]", id); // backend samajh sake ke yeh array hai
        });
      } else {
        formData.append(key, data[key])
      }
    }
    if (item?.id) {
      dispatch(updateInterpreter(formData, item?.id, submitCallback));
    } else
      dispatch(addInterpreter(formData, submitCallback));

  }

  // #region States dropdown

  useEffect(() => {
    dispatch(fetchStates(1, { id: item?.state?.id }))
    if (item?.state?.name && item?.state?.id) {
      setfilterStates({
        value: item?.state?.id || "",
        label: item?.state?.name || "",
      })
    } else {
      setfilterStates(null)
    }
  }, [item?.state])


  const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchStates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    setAllStates(result?.data)
    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region Language dropdown
  const [languageState, setLanguageState] = useState({
    label: "",
    value: ""
  })

  useEffect(() => {
    setLanguageState(
      item?.languages?.map(val => ({
        label: val?.language?.name || "",
        value: val?.language?.id || ""
      }))
    );
  }, [item?.languages]);


  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map(language => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  const options = {
    apiKey: "free",
    maxFileCount: 1
  };

  useEffect(() => {
  if (item?.zone?.id && item?.zone?.name) {
    setFilterZone({
      value: item?.zone?.id,
      label: item?.zone?.name,
    });
    setValue("zone_id", item?.zone?.id); // react-hook-form ke liye
  } else {
    setFilterZone(null);
    setValue("zone_id", "");
  }
}, [item?.zone]);



  const filteredZonesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchZones(
      page,
      { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue },
      true,
      true
    ));

    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>

        <div className="row-primary">
          <h2>Profile Picture</h2>

          <div className='Upload_wrapper'>
            {(localImage || item?.user?.image) &&
              <div className='image_preview'>
                <ProfilePicture imageUrl={localImage || cdn + item?.user?.image} />
              </div>
            }
            <div className="w-100">
              <Controller
                name="image"
                control={control}
                render={({ field }) =>
                (
                  <UploadButton options={options}
                    onComplete={files => {
                      const file = files[0];
                      setLocalImage(file?.fileUrl)
                      field.onChange(file?.originalFile?.file)
                    }}>
                    {({ onClick }) =>
                      <button type='button' onClick={onClick}>
                        <i className="fa-solid fa-camera"></i>&nbsp;&nbsp;
                        <span>Upload New</span>
                      </button>
                    }
                  </UploadButton>
                )}
              />

              {error?.errors?.image?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="row-primary">
          <h2>First Name *</h2>
          <div className="w-100">
            <Controller
              name="first_name"
              control={control}
              render={({ field }) => <input className={`input-in type_inp ${error?.errors?.first_name ? "border-red" : ""} `} type="text" name='first-name' placeholder='First name' required {...field} />}
            />
            {error?.errors?.first_name?.map((error) => (
              <div style={{ marginTop: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Last Name *</h2>
          <div className="w-100">
            <Controller
              name="last_name"
              control={control}
              render={({ field }) => <input className={`input-in type_inp ${error?.errors?.last_name ? "border-red" : ""} `} type="text" name='last-name' placeholder='Last name' required {...field} />}
            />
            {error?.errors?.last_name?.map((error) => (
              <div style={{ marginTop: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Email *</h2>
          <div className="w-100">
            <Controller
              name="email"
              control={control}

              render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" name='email' required
                pattern={
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                }
                placeholder="Email Address"
                {...field}
              />}
            />
            {error?.errors?.email?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Password {item?.id ? "" : "*"}</h2>
          <div className="w-100">
            <input className="input-in type_inp" type="password" {...register("password")} name='password' placeholder="Password" required={item?.id ? false : true} />
            {error?.errors?.password?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Confirm Password {item?.id ? "" : "*"}</h2>
          <div style={{ width: "100%" }}>
            <input className="input-in type_inp" type="password"
              {...register("password_confirmation", {
                validate: (value) =>
                  value === watch("password") || "Passwords do not match",
              })}
              name='password_confirmation'
              required={item?.id ? false : true}
              placeholder="Confirm Password" />

            {errors?.password_confirmation &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.password_confirmation?.message} />
              </div>
            }
            {error?.errors?.password_confirmation?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Phone Number *</h2>
          <div className="w-100">
            <Controller
              name="phone"
              control={control}
              render={({ field }) => <PhoneInput className="input-in type_inp" type="tel" name='phone' placeholder='Phone number' required {...field} />}
            />
            {error?.errors?.phone?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Address</h2>
          <div className="w-100">
            <Controller
              name="address"
              control={control}
              render={({ field }) => <input className={`input-in type_inp ${error?.errors?.address ? "border-red" : ""} `} type="text" name='address' placeholder='Address' {...field} />}
            />
            {error?.errors?.address?.map((error) => (
              <div style={{ marginTop: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary interpreter_states">
          {/* <div> */}
          <h2>Select State *</h2>

          <Controller
            name="state_id"
            control={control}
            rules={
              item?.state?.lenght == 0 && {
                required: "Please select a state"
              }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement='auto'
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={filterStates}
                  loadOptions={filteredStatesLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    setfilterStates(obj)
                    field.onChange(obj?.value);
                  }}
                  additional={{
                    page: 1,
                  }}
                />
                {errors?.state_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.state_id?.message} />
                  </div>
                }

                {error?.errors?.state_id?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
              </div>
            }
          />
          {/* </div> */}
          {/* <div> */}
          <h3 className='text-nowrap'>City*</h3>

          <div className="w-100">
            <Controller
              name="city_id"
              rules={{
                required: "Please enter a city"
              }}
              control={control}
              render={({ field }) =>
                <input className="input-in type_inp" type="text" name='city_id' required placeholder="City"
                  {...field}
                />
              }
            />
            {errors?.city_id?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.city_id?.message} />
              </div>
            }


            {error?.errors?.city_id?.map((error) => (
              <div style={{ marginTop: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
            {/* </div> */}
          {/* <div> */}

          <h3 className='text-nowrap'>Zip Code *</h3>

          <div className='w-100'>
            <Controller
              name="zip_code"
              rules={{
                required: "Please enter a zipcode"
              }}
              control={control}
              render={({ field }) =>
                <input className={`input-in type_inp ${error?.errors?.zip_code ? "border-red" : ""} `} type="text" name='zip_code' placeholder="Zip Code"
                  {...field}
                />
              }
            />
            {errors?.zip_code?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.zip_code?.message} />
              </div>
            }


            {error?.errors?.zip_code?.map((error) => (
              <div style={{ marginTop: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}

          </div>
          {/* </div> */}
        </div>

        <div className="row-primary">
          <h2>Select Languages *</h2>
          <Controller
            name="language_ids"
            required
            rules={{
              required: "Languages must be specified",
            }}
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement='auto'
                    isMulti
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={languageState}
                    loadOptions={filteredLanguagesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setLanguageState(selected)
                      field.onChange(selected.map((opt) => opt.value))
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.language_ids?.message && <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.language_ids?.message} />
                </div>}

                {error?.errors?.language_ids?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
              </div>
            }
          />
        </div>

        <div className="row-primary">
          <h2>Employment Type *</h2>

          <Controller
            name="employment_type"
            control={control}
            rules={{ required: "Please select an employment type" }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  options={EMPLOYMENT_TYPE_OPTIONS}
                  value={EMPLOYMENT_TYPE_OPTIONS.find((opt) => opt.value === field.value) || null}
                  onChange={(value) => field.onChange(value)}
                  isClearable={false}
                  disabledSearch
                  placeholder="Select ..."
                />
                {errors?.employment_type?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.employment_type?.message} />
                  </div>
                }

                {error?.errors?.employment_type?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
              </div>
            }
          />

        </div>

        {employmentType !== 'freelancer' &&
          <div className="row-primary">
            <h2>Select Zone *</h2>

            <Controller
              name="zone_id"
              control={control}
              rules={{ required: "Please select a zone" }}
              render={({ field }) =>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement='auto'
                    styles={{ ...selectCustomStyles }}
                    value={filterZone || null}  // UI default
                    loadOptions={filteredZonesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(obj) => {
                      setFilterZone(obj);
                      field.onChange(obj?.value); // form value
                    }}
                    additional={{ page: 1 }}
                  />
                  {errors?.zone_id?.message &&
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.zone_id?.message} />
                    </div>
                  }

                  {error?.errors?.zone_id?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              }
            />

          </div>
        }

        {/* <InterpreterRate control={control} error={error} errors={errors} item={item} dispatch={dispatch} setValue={setValue} watch={watch} isClient={false} /> */}

        {statusPerm &&
          <div className="row-primary template_switch" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>Status</h2>
            <CustomSwitch
              labelText="active"
              checked={status == 1 ? true : false}
              handleChange={(checked) => setStatus(checked ? 1 : 0)}
            />
          </div>
        }


        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            loader={loader}
            btnText={item?.id ? "Update" : "Create"}
          />
        </div>
      </form>
    </div>
  )
}

const AddInterpreter = ({ item, onClose, callback, show, statusPerm }) => {

  const closeButton = useRef(null)
  const refModal = useRef(null)
  const handleModalDismiss = () => {
    closeButton.current.click()
    onClose()
  };
  useEffect(() => {


    const modalElement = refModal.current;

    if (modalElement) {
      // Attach the event listener
      modalElement.addEventListener("hidden.bs.modal", handleModalDismiss);
    }

    return () => {
      if (modalElement) {
        // Clean up the event listener
        modalElement.removeEventListener("hidden.bs.modal", handleModalDismiss);
      }
    };
  }, []);

  return (
    <div className={`modal fade`} ref={refModal} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Interpreter</h5>
            <button onClick={handleModalDismiss} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeButton}></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddInterpreterForm item={item} handleClose={handleModalDismiss} callback={callback} show={show} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddInterpreter
